import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LoginIcon from '@mui/icons-material/Login';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import { useAuth } from '../auth';
import { useColorMode } from '../theme';
import { SIDEBAR_WIDTH } from './Sidebar';

export const Header = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showAvatarMenu, setShowAvatarMenu] = React.useState<boolean>(false);

  const auth = useAuth();
  const { mode, toggleColorMode } = useColorMode();

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setShowAvatarMenu(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setShowAvatarMenu(false);
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
          ml: `${SIDEBAR_WIDTH}px`,
          backgroundColor: 'background.paper',
          color: 'text.primary',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, fontWeight: 600 }}
          >
            Mass Rating & Analysis Portal
          </Typography>
          <IconButton
            aria-label="toggle light/dark mode"
            onClick={toggleColorMode}
            color="inherit"
          >
            {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
          {auth.user ? (
            <>
              Hello {auth.user?.userName}
              <IconButton
                size="large"
                aria-label={`account of ${auth.user?.userName}`}
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleAvatarClick}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="avatar-menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={showAvatarMenu}
                onClose={handleClose}
              >
                <MenuItem onClick={auth.actions.logout}>
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <IconButton
                size="large"
                aria-label="login"
                aria-haspopup="false"
                onClick={auth.actions?.login}
                color="inherit"
              >
                <LoginIcon />
                <Typography sx={{ ml: '10px' }}>Login</Typography>
              </IconButton>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};
